module.exports = __webpack_public_path__ + "images/bgImg.bae2453f.webp";